export default {"src":"/_next/static/media/ok.42b45a8c.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};